import {
  FaInstagram,
  FaFacebookF,
  FaTiktok,
  FaYoutube,
  FaPinterestP,
  FaXTwitter,
  FaLinkedinIn,
  FaThreads,
  FaAmazon,
} from "react-icons/fa6";

// Fixed platform order + brand identity, shared by Admin manager and public Footer.
export const SOCIAL_ICONS = {
  instagram: { Icon: FaInstagram, color: "#E4405F", placeholder: "https://instagram.com/yourhandle" },
  facebook: { Icon: FaFacebookF, color: "#1877F2", placeholder: "https://facebook.com/yourpage" },
  tiktok: { Icon: FaTiktok, color: "#000000", placeholder: "https://tiktok.com/@yourhandle" },
  youtube: { Icon: FaYoutube, color: "#FF0000", placeholder: "https://youtube.com/@yourchannel" },
  pinterest: { Icon: FaPinterestP, color: "#BD081C", placeholder: "https://pinterest.com/yourprofile" },
  x: { Icon: FaXTwitter, color: "#000000", placeholder: "https://x.com/yourhandle" },
  linkedin: { Icon: FaLinkedinIn, color: "#0A66C2", placeholder: "https://linkedin.com/in/yourprofile" },
  threads: { Icon: FaThreads, color: "#000000", placeholder: "https://threads.net/@yourhandle" },
  amazon: { Icon: FaAmazon, color: "#FF9900", placeholder: "https://amazon.com/author/yourname" },
};

export const SOCIAL_ORDER = [
  "instagram",
  "facebook",
  "tiktok",
  "youtube",
  "pinterest",
  "x",
  "linkedin",
  "threads",
  "amazon",
];
